import {createSlice} from "@reduxjs/toolkit";

const initialPopupInvoicesList = {
  dataLoading: false,
  entities: null,
  error: null,
};
export const callTypes = {
  data: "data",
  action: "action"
};

export const popupInvoicesListSlice = createSlice({
  name: "popupInvoicesList",
  initialState: initialPopupInvoicesList,
  reducers: {
    popupInvoicesListFetched: (state, action) => {
      const {entities} = action.payload;
      state.dataLoading = false;
      state.error = null;
      state.entities = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesListError = null;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
